module.exports = __webpack_public_path__ + "img/no-items.0c334764.svg";